import style from './style.module.scss'
import editCoachIcon from 'components/Admin/images/edit-coach.svg'
import ImageModal from 'components/Admin/DirectoryPage/ImageModal'
import { useState } from 'react'
import { useAffiliate } from 'hooks/useAffiliate'

type Props = {
  id: number
}

export default function CoachAvatar({ id }: Props) {
  const { selectedAffiliate: affiliateDetail } = useAffiliate()
  const [imageModalOpen, setImageModalOpen] = useState<boolean>(false)
  const [avatarImageUrl, setAvatarImageUrl] = useState<string>(
    affiliateDetail?.images?.coaches?.find((coach) => coach.id === id)?.image
      ?.url,
  )

  return (
    <>
      <div className={style.imageContainer}>
        <img className={style.image} src={avatarImageUrl} alt='coach avatar' />
        <div className={style.overlay}>
          <img onClick={() => setImageModalOpen(true)} src={editCoachIcon} />
        </div>
      </div>
      {imageModalOpen && (
        <ImageModal
          type='coach'
          affiliateId={affiliateDetail.id}
          userId={id}
          setImageUrl={setAvatarImageUrl}
          isOpen={imageModalOpen}
          setIsOpen={setImageModalOpen}
        />
      )}
    </>
  )
}
